"use client";

import { useState } from "react";
import Link from "next/link";
import { usePathname, useRouter } from "next/navigation";
import { Home, LayoutList, Plus, KanbanSquare, Menu } from "lucide-react";
import { PopupMenuCriacao } from "../app/planejamento/PopupMenuCriacao";

export function BottomNavigation() {
  const pathname = usePathname();
  const [showPopup, setShowPopup] = useState(false);
  const router = useRouter();

  const handleAbrirIniciativa = () => {
    setShowPopup(false);
    router.push('/planejamento?aba=create&open=iniciativa');
  };

  const handleAbrirEpico = () => {
    setShowPopup(false);
    router.push('/planejamento?aba=create&open=epico');
  };

  const handleAbrirTarefa = () => {
    setShowPopup(false);
    router.push('/planejamento?aba=create&open=tarefa');
  };

  // Não mostrar o menu na página de login
  if (pathname === '/' || pathname === '/login') {
    return null;
  }

  return (
    <>
      <nav className="fixed bottom-0 left-0 right-0 bg-white border-t border-slate-200 px-2 py-2 z-40 safe-area-bottom">
        <div className="max-w-md mx-auto flex items-center justify-around">
          {/* Home */}
          <Link
            href="/menu"
            className={`flex flex-col items-center gap-1 px-3 py-1 rounded-lg transition-colors ${
              pathname === '/menu' ? 'text-purple-600' : 'text-slate-400 hover:text-slate-600'
            }`}
          >
            <Home className="w-6 h-6" />
            <span className="text-[10px] font-medium">Home</span>
          </Link>

          {/* Backlog */}
          <Link
            href="/planejamento?aba=backlog"
            className={`flex flex-col items-center gap-1 px-3 py-1 rounded-lg transition-colors ${
              pathname === '/planejamento' ? 'text-purple-600' : 'text-slate-400 hover:text-slate-600'
            }`}
          >
            <LayoutList className="w-6 h-6" />
            <span className="text-[10px] font-medium">Backlog</span>
          </Link>

          {/* Plus - Central */}
          <button
            onClick={() => setShowPopup(true)}
            className="flex flex-col items-center gap-1 px-3 py-1 rounded-lg transition-colors text-purple-600 hover:text-purple-700"
          >
            <div className="w-12 h-12 bg-purple-500 rounded-full flex items-center justify-center shadow-lg shadow-purple-500/40 hover:bg-purple-600 transition-colors">
              <Plus className="w-6 h-6 text-white" />
            </div>
            <span className="text-[10px] font-medium">Adicionar</span>
          </button>

          {/* Quadro de Tarefas */}
          <Link
            href="/planejamento?aba=kanban"
            className={`flex flex-col items-center gap-1 px-3 py-1 rounded-lg transition-colors ${
              pathname === '/planejamento' ? 'text-purple-600' : 'text-slate-400 hover:text-slate-600'
            }`}
          >
            <KanbanSquare className="w-6 h-6" />
            <span className="text-[10px] font-medium">Quadro</span>
          </Link>

          {/* Menu */}
          <Link
            href="/menu"
            className={`flex flex-col items-center gap-1 px-3 py-1 rounded-lg transition-colors ${
              pathname === '/menu' ? 'text-purple-600' : 'text-slate-400 hover:text-slate-600'
            }`}
          >
            <Menu className="w-6 h-6" />
            <span className="text-[10px] font-medium">Menu</span>
          </Link>
        </div>
      </nav>

      {/* Popup de criação */}
      {showPopup && (
        <PopupMenuCriacao
          onAbrirIniciativa={handleAbrirIniciativa}
          onAbrirEpico={handleAbrirEpico}
          onAbrirTarefa={handleAbrirTarefa}
          onFechar={() => setShowPopup(false)}
        />
      )}
    </>
  );
}
